"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    (0, _jquery2.default)("div.dropzone").each(function () {
        var dropzone = (0, _jquery2.default)(this).get(0).dropzone;
        if (dropzone) {
            dropzone.options.maxFilesize = 60;
            dropzone.options.dictFileTooBig = Resx.DropZone.FileTooBig;
        }

        if (dropzone && !dropzone.options.imagesOnly) {
            dropzone.options.previewTemplate = templateFile();
        }
    });
};

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _localize = require("linksoft/core/localize");

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('DropZone');

;

function templateFile() {
    return "\n<div class=\"dropzpone-file\">\n    <div class=\"title\">\n        <span data-dz-name></span> <small class=\"pull-right\"><span data-dz-size></span></small>\n    </div>\n    <div class=\"icons\">\n        <a data-dz-action-download target=\"_blank\">\n            <i class=\"fa fa-download blue\"  data-toggle=\"tooltip\" data-original-title=\"" + Resx.DropZone.Download + "\"></i>\n        </a>\n        <i class=\"fa fa-clipboard\" data-toggle=\"tooltip\" data-original-title=\"" + Resx.DropZone.CopyToClipboard + "\" data-dz-action-clipboard></i>\n        <i data-dz-remove class=\"fa fa-remove red\" data-toggle=\"tooltip\" data-original-title=\"" + Resx.DropZone.Delete + "\"></i>\n    </div>\n    <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n    <div class=\"dz-success-mark\"><span></span></div>\n    <div class=\"dz-error-mark\"><span></span></div>\n    <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n</div>";
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/dropzoneMaxFilesize.js
// module id = 439
// module chunks = 0